import React from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material'

import pointIcon from '../../media/point_apport_icon.svg'
import shopIcon from '../../media/boutique_icon.svg'
import DreyfusShopIcon from '../../media/boutique_dreyfus_icon.svg'
import Zone from '../organisms/Zone'
import usePlaces from '../../hooks/usePlaces'

const StyledTitle = styled((props) => <Typography variant="h4" {...props} />)(({ theme }) => ({
	fontSize: 16,
	fontWeight: 800,
	position: 'relative',

	'& strong': {
		color: 'white',
		backgroundColor: 'black',
		padding: '.25rem .687rem',
		marginBottom: '0.6rem',
		display: 'table',
		position: 'relative',
		zIndex: 2,
		fontWeight: 800,
	},

	'&:before': {
		zIndex: 1,
		width: '7.8rem',
		height: '7.8rem',
		borderRadius: '50%',
		content: '" "',
		position: 'absolute',
		left: '-1.4rem',
		top: '-6.4rem',
		backgroundColor: theme.palette.primary.light,
	},

	'& img': {
		position: 'absolute',
		left: '0rem',
		top: '-4rem',
		zIndex: 3,
	},
}))

const StyleSubtitle = styled((props) => <Typography variant="h5" {...props} />)(({ theme }) => ({
	fontSize: 16,
	fontWeight: 700,
	margin: '.6rem 0',
}))

const StyledBody = styled((props) => <Typography variant="h6" {...props} />)(({ theme }) => ({
	fontSize: 16,
	fontWeight: 400,
	margin: '.5rem 0 .4rem',
}))

const StyledFooter = styled((props) => <Typography variant="h6" {...props} />)(({ theme }) => ({
	fontSize: 16,
	fontWeight: 400,
	margin: '0',
}))

const ListHeader = () => {
	const { isLoading, places } = usePlaces()

	return (
		<Zone color="none">
			<Grid
				container
				sx={(theme) => ({
					m: 0,
					pt: 7,

					justifyContent: 'space-between',
					'& .MuiTypography-root': {
						color: 'black',
						textAlign: 'left',
					},
					'& .MuiGrid-root': {
						pr: 2,
					},
					[theme.breakpoints.down('md')]: {
						justifyContent: 'flex-start',
						pl: 2,

						'& .MuiGrid-root': {
							mt: 20,
							pl: 0,
							'&:first-of-type': {
								mt: 6,
							},
						},
					},
				})}
			>
				{!isLoading &&
					places.map(({ title, description, street, city, opens }, index) => (
						<Grid item xs={12} pt={0} md={2.6} key={index}>
							<StyledTitle>
								<strong>{title}</strong>
								{index === 0 && <img src={pointIcon} alt="" />}
								{index === 1 && <img src={shopIcon} alt="" />}
								{index === 2 && <img src={DreyfusShopIcon} alt="" />}
							</StyledTitle>
							<StyleSubtitle>{description}</StyleSubtitle>
							<StyledBody>
								<Typography dangerouslySetInnerHTML={{ __html: `${street}, ${city}` }} />
							</StyledBody>
							<StyledFooter>
								{opens.map((open) => (
									<Typography
										component="span"
										dangerouslySetInnerHTML={{ __html: open }}
										key={open}
									/>
								))}
							</StyledFooter>
						</Grid>
					))}
			</Grid>
		</Zone>
	)
}

export default ListHeader
